/* @flow */

export default {
  // DEV_APP_ID: 'V3BHStx9Hn3moVj3PgP6',
  // DEV_APP_CODE: '0CVpr5LTgQwZ5c1LiXdTIg',
  DEV_APP_ID: 'Ear0VRMz4nV8YBtgwF4D',
  DEV_APP_CODE: '1IKMeASqkmiJHWCi42oSvg',
  PROD_APP_ID: 'Ear0VRMz4nV8YBtgwF4D',
  PROD_APP_CODE: '1IKMeASqkmiJHWCi42oSvg'
};
